export default class ImageMetadata {
  constructor(crc32c, name, publicUrl, size) {
    this.crc32c = crc32c;
    this.name = name;
    this.publicUrl = publicUrl;
    this.size = size;
  }
}
